import React from "react";
import "./DeletePopup.css";

const DeletePopup = ({ show, onClose, onConfirm }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2>Delete</h2>
        <p>Are you sure you want to delete ?</p>
        <div className="modal-actions">
          <button className="admin-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="admin-delete-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
